import { render } from "./MentionPicker.vue?vue&type=template&id=45bb9663&scoped=true&ts=true"
import script from "./MentionPicker.vue?vue&type=script&lang=ts"
export * from "./MentionPicker.vue?vue&type=script&lang=ts"

import "./MentionPicker.vue?vue&type=style&index=0&id=45bb9663&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bb9663"]])

export default __exports__